import { request } from "./api.js";

export async function startPhoneAuth(phoneNumber) {
  return request("/api/auth/phone/start", {
    method: "POST",
    body: JSON.stringify({ phoneNumber: String(phoneNumber || "").trim() }),
    requireAuth: false,
  });
}

export async function resolvePhoneAuthAccount(phoneNumber) {
  const params = new URLSearchParams({
    phoneNumber: String(phoneNumber || "").trim(),
  });
  return request(`/api/auth/phone/account?${params.toString()}`, {
    method: "GET",
    forceFresh: true,
  });
}
